import React, { useState } from 'react';
import { TAB_MODS } from '../../../../config/mods';
import MarketplacesList from './components/MarketplacesList';
import MarketplaceForms from './components/MarketplaceForms';

const MarketplacesSection = () => {
  const [settings, setSettings] = useState({
    mode: TAB_MODS.LIST,
    marketplaceCode: null,
    organization: '',
  });

  const handleSwitchMarketplaceMode = (mode, marketplaceCode, organization) => {
    setSettings({
      mode: mode ? mode : settings.mode,
      marketplaceCode: marketplaceCode ? marketplaceCode : settings.marketplaceCode,
      organization: organization ? organization : settings.organization,
    });
  };

  const displayMarketplaceComponent = () => {
    switch (settings.mode) {
      case TAB_MODS.LIST:
        return <MarketplacesList handleSwitchMarketplaceMode={handleSwitchMarketplaceMode} />;
      case TAB_MODS.EDIT:
        return (
          <MarketplaceForms
            handleSwitchMarketplaceMode={handleSwitchMarketplaceMode}
            mode={settings.mode}
            marketplaceCode={settings.marketplaceCode}
          />
        );
      case TAB_MODS.ADD:
        return (
          <MarketplaceForms
            handleSwitchMarketplaceMode={handleSwitchMarketplaceMode}
            mode={settings.mode}
            organization={settings.organization}
          />
        );
      default:
        return <p>Ошибка отображения маркетплейсов</p>;
    }
  };

  return (
    <div>
      <h4 className="header-title mt-1">Маркетплейсы</h4>
      <div style={{ minHeight: '200px' }}>{displayMarketplaceComponent()}</div>
    </div>
  );
};

export default MarketplacesSection;
